// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#inputPhone{width:195px;margin-right:8px}.btn_phone{background-color:#40868f;color:#fff;padding:1em;margin:1px;display:inline-block;vertical-align:top}.el-dialog{width:500px}.el-input{width:90%}.refresh{position:relative;font-size:30px;top:6px;left:10px}@media(max-width:540px){.el-dialog{width:90%}}", ""]);
// Exports
module.exports = exports;
